/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { computed, ref, watch, Component } from 'vue';
import { IapComponent } from "../../../component/domain/iapComponent";
import { LocalService, MessageService } from "../../../../../common/infrastructure/servicios";
import { ExpresionEngine } from "../../../expression/infrastructure/helper/expressionEngine";
import CatalogExpConst from "../../../catalog/domain/const/CatalogExpConst";
import CatalogObjectTypeConst from "../../../catalog/domain/const/CatalogObjectTypeConst";
import { Container } from "inversify";
import { IServiceSearch } from "../../../search/application/IServiceSearch";
import { TYPES } from "../../../../../common/domain/types";
import HelperLoading from "../../../../../common/infrastructure/funciones/HelperLoading";
import { IapDataSource } from "../../../datasource/domain/iapDataSource";
import { IapComponentDataSource } from "../../../component/domain/iapComponentDataSource";
import FiltroBusquedaConst from "../../../../../common/domain/constantes/FiltroBusquedaConst";
import { SearchData } from "../../../search/domain/search";
import dataSourceFieldConst from '../../../datasource/domain/const/dataSourceFieldConst';
import ExpressionNomenclatorConst from "../../../expression/domain/const/ExpressionNomenclatorConst";
import BaseControlTypeConst from "../Constants/BaseControlTypeConst";
import AutocompleteTypeConst from "../Constants/AutocompleteTypeConst";
import CatalogModelValueConst from "../../../catalog/domain/const/CatalogModelValueConst";
import WidgetComponentDataTree from "../../../designer/domain/widgetComponent";
import { IapCatalog } from '../../../catalog/domain/iapCatalog';
import HelperCommon from "../../../../../common/infrastructure/funciones/HelperCommon";
import CatalogAttrConst from "../../../catalog/domain/const/CatalogAttrConst";
//@ts-ignore:disable-next-line
import debounce from 'lodash.debounce';
import { dataUpdate } from "../../../dataupdate/domain/dataUpdate";
import { IServiceDataUpdate } from "../../../dataupdate/application/IServiceDataUpdate";
import OperationDataTypeConst from "../../../../../common/domain/constantes/OperationDataTypeConst";
import { clave, claveNew } from "../../../dataupdate/domain/clave";
import SqlTypesConst from "../../../../../common/domain/constantes/SqlTypesConst";
import fechaComp from "../../../../../common/infrastructure/funcionescompartidas/fechaComp";
import DataSourceUtilComp from "../../../crud/infrastructure/functions/dataSourceUtilComp";
import DataSourceConst from "../../../crud/infrastructure/functions/dataSourceConst";
import KeysDataModel from "../keysDataModel";
import KeysDataModelComponentDataSource from "../keysDataModelComponentDataSource";
import KeysDataModelAttribute from "../keysDataModelAttribute";
import ComponentUtil from "../../../designer/infrastructure/component/util/componentUtil";
import useVuelidate from '@vuelidate/core';
import { helpers, required, requiredIf } from '@vuelidate/validators';
import { IapComponentDataSourceFieldConfiguration } from "../../../component/domain/iapComponentDataSourceFieldConfiguration";
import { IapDataSourceField } from "../../../datasource/domain/iapDataSourceField";
import HelperUtils from "../../../../../common/infrastructure/funciones/HelperUtils";
import ControlTypeConst from "../Constants/ControlTypeConst";
import { MenuItemClass } from '../Controls/MenuItemClass';
import MenuItemTypeConst from "../Constants/MenuItemTypeConst";
import { useRouter } from 'vue-router'
import { IapWorkFlow } from "../../../workflow/domain/service/iapWorkFlow";
import { executeWorkFlow } from "../../../workflow/infrastructure/component/rete/rete/editor";
import CatalogEventConst from "../../../catalog/domain/const/CatalogEventConst";
import { IapComponentEvent } from "../../../component/domain/iapComponentEvent";
import HelperOperationData from "../../../../../common/infrastructure/funciones/HelperOperationData";
import EventBus from '../../../../../common/infrastructure/event-bus';
import EventConst from "../../../../../common/domain/constantes/EventConst";
import { DataSourceDataBaseService } from '../../../datasource/application/DataSourceDataBaseService';
import { MessageType } from "../../../../../common/infrastructure/servicios/MessageService";
import { Dictionary } from "../../../expression/domain/dictionary";
import DataSourceComp from "../../../crud/infrastructure/functions/dataSourceComp";
import { IapExpression } from '../../../expression/domain/iapExpression';
import helperCatalog from "../../../catalog/infrastructure/helper/helperCatalog";
import { InteractionEvent } from '../../../interaction/domain/interactionEvent';
import InteractionConst from '../../../interaction/domain/interactionConst';
import { IapComponentAttribute } from '../../../component/domain/iapComponentAttribute';
import { fetchWrapper } from '../../../../../common/infrastructure/funciones/helperFetch';
import Environment from '../../../../../common/domain/constantes/environment';
import { parseStackingContexts } from 'html2canvas/dist/types/render/stacking-context';
import { Store } from 'vuex';

export default function ComponentCommon(
  props: any,
  context: any,
  store:Store<any>
) {

  const { getTreeFlat } = ComponentUtil();
  const { formateaFecha } = fechaComp();
  const debounceTime = 1200;
  const componentInput = props.Component ?? props.data;
  const inputRootParentId = props.rootParentId;
  const container: Container = props.container;
  const Component: WidgetComponentDataTree = componentInput;
  const rootParentId = inputRootParentId;
  let debounceUpdateData: any;
  let submitted = ref(false);


  // se inicializa aqui el vmodel
  const vmodel = ref();
  const router = useRouter();
  const lookUpData = ref();
  const fieldKey = ref('');
  const fieldKeyComponentDataSourceId = ref(-1)
  const keyComponentEventBus = rootParentId.toString() + Component.id.toString() + EventConst.INTERACTION;
  const loaded = computed(() => {
    return Component.loaded
  });


  const componentData = computed({
    get: () => Component,
    set: (val) => context.emit("update:Component", val),
  });


  const componentDataSources = computed({
    get: () => props.dataSources as IapComponentDataSource[],
    set: (val) => context.emit("update:dataSources", val),
  });


  const getDictionaryKeys = () => {
    const localData = LocalService.getValue(LocalService.COMPONENTS_EXP + (rootParentId ?? -1).toString());
    const data = JSON.parse(localData ?? '[]')

    if (data && data?.length > 0) {
      return data.map((x: any) => x.key);
    }
    return [];

  }


  const dictionaryKeys = getDictionaryKeys();

  const getModelValue = () => {
    let model: any;
    const mv = getProperty(BaseControlTypeConst.MODELVALUE)


    if (mv && mv.value) {

      if (mv.idModelValueType == CatalogModelValueConst.MODELVALUE_PROPERTY) {
        // hay que sacar las propiedades del padre
        let _model = props.rootParentAttr?.find((x: any) => x.id == mv.value)
        if (_model == null) {
          _model = Component.iapComponentAttributes?.find(x => x.id == mv.value)
        }
        if (_model) {
          model = _model['value']
        }
      }
      else {

        // hay que sacar el field del ds
        const ids = mv.value?.split('#');
        const dataSourceFieldId = ids[0];
        fieldKeyComponentDataSourceId.value = parseInt(ids[1]);
        // para las tablas, dataviews,...

        const data = props.slotProps?.data ?? props.slotProps?.slotProps?.data

        if (data) {


          fieldKey.value = getDsFieldKey(fieldKeyComponentDataSourceId.value, dataSourceFieldId) as any

          if (fieldKey.value) {
            model = data[fieldKey.value]
          }
        }
        else {
          model = getDsFieldModel(fieldKeyComponentDataSourceId.value, dataSourceFieldId);
        }
      }
    }

    return model;
  };

  const setModelValue = (value: any) => {
    let model: any;
    const mv = getProperty(BaseControlTypeConst.MODELVALUE)

    if (mv && mv.value) {

      if (mv.idModelValueType == CatalogModelValueConst.MODELVALUE_PROPERTY) {
        // validamos que sea un guid
        if (HelperUtils.isUUID(mv.value)){
        // hay que sacar las propiedades del padre
        let _model = props.rootParentAttr?.find((x: any) => x.id == mv.value)
        if (_model == null) {
          _model = Component.iapComponentAttributes?.find(x => x.id == mv.value)
        }
        if (_model) {
          _model['value'] = value;   
          updateDictionary([ExpressionNomenclatorConst.EXPNOM_ATTRIBUTES, _model['id']].join(ExpressionNomenclatorConst.SEPARATOR), value);    
        }
        
        }

      }
      else {

        // hay que sacar el field del ds
        const ids = mv.value?.split('#');
        const dataSourceFieldId = ids[0];
        const componentDataSourceId = parseInt(ids[1]);

        // para las tablas, dataviews,...

        const data = props.slotProps?.data ?? props.slotProps?.slotProps?.data

        if (data) {

          const fieldKey = getDsFieldKey(componentDataSourceId, dataSourceFieldId)

          if (fieldKey) {
            data[fieldKey] = value
          }
        }
        else {
          model = setDsFieldModel(mv.id,componentDataSourceId, dataSourceFieldId, value);
          
        }
      }
    }


  };



  const getDsFieldKey = (componentDataSourceId: number, dataSourceFieldId: string) => {
    const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);
    if (dsc) {
      const field = dsc.dataSource.iapDataSourceFields.find(x => x.id == dataSourceFieldId)
      if (field) {
        const fieldKey = [dsc.dataSource?.iapDataSourceDataBase?.idBaseDatos, (!HelperCommon.isNullOrWhitespace(field.tableNameAlias ?? '') ? field.tableNameAlias : field.tableName), (!HelperCommon.isNullOrWhitespace(field.fieldAlias ?? '') ? field.fieldAlias : field.field)].join(DataSourceConst.DELIMITERFIELDS)
        return fieldKey;
      }
    }

    return null;
  }

  const getDsFieldModel = (componentDataSourceId: number, dataSourceFieldId: string) => {

    const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);
    if (dsc) {
      const field = dsc.dataSource.iapDataSourceFields.find(x => x.id == dataSourceFieldId)
      if (field) {
        fieldKey.value = getDsFieldKey(componentDataSourceId, dataSourceFieldId) as any
        if (fieldKey.value) {
          const first = dsc.dataSource.items?.find((x: any) => x !== undefined)

          const model = first?.[fieldKey.value];// dsc.dataSource.items.find(x=>x!==undefined)?.map(x=> x[fieldKey])
          return model;
        }

      }
    }
    return null;
  }

  const setDsFieldModel = (componentAttributeId: string, componentDataSourceId: number, dataSourceFieldId: string, value: any) => {

    const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);
    if (dsc) {
      const field = dsc.dataSource.iapDataSourceFields.find(x => x.id == dataSourceFieldId)
      if (field) {
        const fieldKey = getDsFieldKey(componentDataSourceId, dataSourceFieldId)
        if (fieldKey) {
          const first = dsc.dataSource.items?.find((x: any) => x !== undefined)
          if (first) {
            first[fieldKey] = value;  
            updateDictionary([ExpressionNomenclatorConst.EXPNOM_DSF, dsc.id, field.id].join(ExpressionNomenclatorConst.SEPARATOR), value);         
          }

        }

      }
    }

  }




  const getModelValueKeys = (): KeysDataModelComponentDataSource | KeysDataModelAttribute | null => {
    const mv = getProperty(BaseControlTypeConst.MODELVALUE)

    if (mv && mv.value) {

      if (mv.idModelValueType == CatalogModelValueConst.MODELVALUE_DATASOURCE) {
        const ids = mv.value?.split('#');
        const _dataSourceFieldId = ids[0];
        const _componentDataSourceId = parseInt(ids[1]);
        return {
          type: CatalogModelValueConst.MODELVALUE_DATASOURCE,
          dataSourceFieldId: _dataSourceFieldId,
          componentDataSourceId: _componentDataSourceId


        } as KeysDataModelComponentDataSource


      }
      else {
        return {
          type: CatalogModelValueConst.MODELVALUE_PROPERTY,
          attributeId: mv.value

        } as KeysDataModelAttribute
      }
    }
    return null
  }


  const getDsLookUpId = () => {
    let dataSourceLookUpId = 0;
    const mv = getProperty(BaseControlTypeConst.MODELVALUE);

    if (mv && mv.value) {
      const ids = mv.value?.split('#');
      const dataSourceFieldId = ids[0];
      const componentDataSourceId = parseInt(ids[1]);

      const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);

      if (dsc) {
        const field = dsc.dataSource.iapDataSourceFields.find(x => x.id == dataSourceFieldId)
        if (field) {
          if (field.dataSourceLookUpId) {
            dataSourceLookUpId = field.dataSourceLookUpId;
          }

        }
      }

      return dataSourceLookUpId;
    }

  }

  const getDsFieldsLookUp = () => {
    let dataSourceLookUpId = 0;
    const mv = getProperty(BaseControlTypeConst.MODELVALUE);

    if (mv && mv.value) {
      const ids = mv.value?.split('#');
      const dataSourceFieldId = ids[0];
      const componentDataSourceId = parseInt(ids[1]);

      const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);

      if (dsc) {
        const field = dsc.dataSource.iapDataSourceFields.find(x => x.id == dataSourceFieldId)
        if (field) {
          if (field.dataSourceLookUpId) {
            dataSourceLookUpId = field.dataSourceLookUpId;
          }

          return field.dataSourceLookUp?.dataSource.iapDataSourceFields;

        }
      }

      return null;
    }

  }

  const getDsLookUp = () => {
    let dataSourceLookUpId = 0;
    const mv = getProperty(BaseControlTypeConst.MODELVALUE);

    if (mv && mv.value) {
      const ids = mv.value?.split('#');
      const dataSourceFieldId = ids[0];
      const componentDataSourceId = parseInt(ids[1]);

      const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);

      if (dsc) {
        const field = dsc.dataSource.iapDataSourceFields.find(x => x.id == dataSourceFieldId)
        if (field) {
          if (field.dataSourceLookUpId) {
            dataSourceLookUpId = field.dataSourceLookUpId;
          }

          return field.dataSourceLookUp;

        }
      }

      return null;
    }

  }

  const getDsLookUpDesc = () => {
    const mv = getProperty(BaseControlTypeConst.MODELVALUE);

    if (mv && mv.value) {
      const ids = mv.value?.split('#');
      const dataSourceFieldId = ids[0];
      const componentDataSourceId = parseInt(ids[1]);

      const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);

      if (dsc) {
        const field = dsc.dataSource.iapDataSourceFields.find(x => x.id == dataSourceFieldId)
        if (field) {
          fieldKey.value = getDsFieldKey(componentDataSourceId, dataSourceFieldId) as any
          if (fieldKey.value) {
            const first = dsc.dataSource.items?.find((x: any) => x !== undefined)

            const desc = first?.[fieldKey.value + DataSourceConst.DELIMITERFIELDLOOKUPDESCRIPTION];// dsc.dataSource.items.find(x=>x!==undefined)?.map(x=> x[fieldKey])
            return desc;
          }

        }
      }
      return null;

    }
  }

  const getComponentDataSourceItemsFromId = (name:string) => {

    const value = getPropertyValue(name);

    if (value) {
      const dsc = componentDataSources.value.find(x => x.id ==  parseInt(value));

      if(dsc && dsc?.dataSource){
          return dsc?.dataSource.items;
      }
    }

    return null;
  }

  const getComponentDataSource = (nameProperty:string) => {

    const value = getPropertyValue(nameProperty);

    if (value) {
      const dsc = componentDataSources.value.find(x => x.id ==  parseInt(value));

      if(dsc){
          return dsc;
      }
    }

    return null;
  }




  const getOptionLabelAutocomplete = ():string => {
    
    const ol = getPropertyValue(AutocompleteTypeConst.OPTIONLABEL);

    if (ol) {
      const ids = ol.split('#');
      const dataSourceFieldId = ids[0];
      const componentDataSourceId = parseInt(ids[1]);

      const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);

      if(dsc && dsc.dataSource && dsc.dataSource.iapDataSourceFields){

        const dsf=dsc.dataSource.iapDataSourceFields.find(dsf=>dsf.id==dataSourceFieldId);
        let key= '';

        if(dsf){
          if (dsf.dataSourceTableAliasId == null) {
            key = [dsc.dataSource?.iapDataSourceDataBase?.idBaseDatos, DataSourceConst.AGGREGATE_TABLE, (!HelperCommon.isNullOrWhitespace(dsf.fieldAlias ?? '') ? dsf.fieldAlias : dsf.field)].join(DataSourceConst.DELIMITERFIELDS);
          }
          else {
            key = [dsc.dataSource?.iapDataSourceDataBase?.idBaseDatos, (!HelperCommon.isNullOrWhitespace(dsf.tableNameAlias ?? '') ? dsf.tableNameAlias : dsf.tableName), (!HelperCommon.isNullOrWhitespace(dsf.fieldAlias ?? '') ? dsf.fieldAlias : dsf.field)].join(DataSourceConst.DELIMITERFIELDS);
          }
        }
       
        if (key) {
          return key;
        }
        
      }
      
    }

    return '';
  }



  const getComponentDataSourceFromModelValue = () => {
    let dataSourceLookUpId = 0;
    const mv = getProperty(BaseControlTypeConst.MODELVALUE);

    if (mv && mv.value) {
      const ids = mv.value?.split('#');
      const dataSourceFieldId = ids[0];
      const componentDataSourceId = parseInt(ids[1]);

      const dsc = componentDataSources.value.find(x => x.id == componentDataSourceId);

      return dsc;
    }

    return null;
  }




  const isAutoSaveDatasourceComponent = (): boolean => {

    if (modelValueKeys && modelValueKeys?.type == CatalogModelValueConst.MODELVALUE_DATASOURCE) {
      const _data = modelValueKeys as KeysDataModelComponentDataSource
      const cds = componentDataSources.value.find(x => x.id == _data.componentDataSourceId);
      return (cds && cds?.autoSave) ?? false;
    }

    return false;
  }



  const booleanify = (value: string): boolean => {
    const truthy: string[] = ["true", "True", "1"];

    return truthy.includes(value);
  };

  const getPropertyId = (propertyName: string, component = Component) => {
    return component.iapComponentAttributes.find((x) => x.name == propertyName)
      ?.id;
  };


  const getPropertyValue = (propertyName: string, component = Component) => {
    return component.iapComponentAttributes.find((x) => x.name == propertyName)
      ?.value;
  };




  const getPropertyValueOption = (propertyName: string, options: any, component = Component) => {

    const valueProp = getPropertyValue(propertyName, component) ?? '';
    const outPut = Object.keys(options.find((x:any) => x !== undefined)).find(x => x.toLowerCase().endsWith(valueProp.toLowerCase()))


    return outPut ?? valueProp;

  };


  const getProperty = (propertyName: string) => {
    return Component.iapComponentAttributes.find((x) => x.name == propertyName);
  };

  const setPropertyValue = (propertyId: string, value: any) => {

    let attr = Component.iapComponentAttributes.find((x:IapComponentAttribute) => x.id == propertyId);
    
    if (attr == undefined){
      attr = props.rootParentAttr?.find((x:IapComponentAttribute) => x.id == propertyId);
    }
    if (attr) {
      attr.value = value;
      updateDictionary([ExpressionNomenclatorConst.EXPNOM_ATTRIBUTES, attr.id].join(ExpressionNomenclatorConst.SEPARATOR), attr.value);
    }

  };

  const setPropertyValueByName = (propertyName: string, value: any) => {
    let attr = Component.iapComponentAttributes.find((x) => x.name == propertyName);
    /*
    if (attr == undefined){
      attr = props.rootParentAttr?.find((x:IapComponentAttribute) => x.name == propertyName);
    }
    */

    if (attr) {
      attr.value = value;
      updateDictionary([ExpressionNomenclatorConst.EXPNOM_ATTRIBUTES, attr.id].join(ExpressionNomenclatorConst.SEPARATOR), attr.value);
    }

  };

  const catalogTypes = () => {
    return helperCatalog.getAllCatalogApp();
  }

  const getCatalogValue = (propertyName: string) => {

    const prop = Component.iapComponentAttributes.find((x) => x.name == propertyName);

    const catalogType = prop?.valueListId;
    const propValue = prop?.value;

    return catalogTypes().find(x => x.id == catalogType)?.iapCatalogs?.find(x => x.id?.toLowerCase() == propValue?.toLowerCase())?.value?.toLowerCase();

  };


  const getCatalogs = (catalogTypeId: string) => {

    return catalogTypes().find((x: any) => x.id == catalogTypeId)?.iapCatalogs;

  };



  const getPropertyBooleanValue = (propertyName: string, component = Component) => {

    return booleanify(
      component.iapComponentAttributes.find((x) => x.name == propertyName)
        ?.value ?? "false"
    );
  };

  const getPropertyNumberValue = (propertyName: string, component = Component) => {
    return Number(
      component.iapComponentAttributes.find((x) => x.name == propertyName)
        ?.value ?? "0"
    );
  };



  const updateDictionary = (key: string, value: any) => {
    const localData = LocalService.getValue(LocalService.COMPONENTS_EXP + (rootParentId ?? -1).toString());
    const data = JSON.parse(localData ?? '[]')

    const reg = data.find((x: any) => x.key == key);
    
    if (reg) {

      reg.value = value;
      LocalService.setValue(LocalService.COMPONENTS_EXP + (rootParentId ?? -1).toString(), JSON.stringify(data))
    }


  }


  const updateCdsDependencies = (ds: IapComponentDataSource, obj: any) => {


    // se actauliza el ds si se usa en el diccionario    
    const keyDs = [ExpressionNomenclatorConst.EXPNOM_DATASOURCE, ds.id, ds.dataSourceId, ds.componentId].join(ExpressionNomenclatorConst.SEPARATOR);
    if (dictionaryKeys.includes(keyDs)) {
      updateDictionary(keyDs, obj)
    }

    // falta actualizar los fields que se usen
    if (ds.dataSource?.items?.length > 0) {
      const item = ds.dataSource?.items[0];

      ds.dataSource.iapDataSourceFields
        .filter(f => dictionaryKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSF, ds.id, f.id].join(ExpressionNomenclatorConst.SEPARATOR)))
        .forEach(f => {
          let key = '';
          if (f.dataSourceTableAliasId == null) {
            key = [ds.dataSource?.iapDataSourceDataBase?.idBaseDatos, DataSourceConst.AGGREGATE_TABLE, (!HelperCommon.isNullOrWhitespace(f.fieldAlias ?? '') ? f.fieldAlias : f.field)].join(DataSourceConst.DELIMITERFIELDS);
          }
          else {
            key = [ds.dataSource?.iapDataSourceDataBase?.idBaseDatos, (!HelperCommon.isNullOrWhitespace(f.tableNameAlias ?? '') ? f.tableNameAlias : f.tableName), (!HelperCommon.isNullOrWhitespace(f.fieldAlias ?? '') ? f.fieldAlias : f.field)].join(DataSourceConst.DELIMITERFIELDS);
          }
          if (key) {
            updateDictionary([ExpressionNomenclatorConst.EXPNOM_DSF, ds.id, f.id].join(ExpressionNomenclatorConst.SEPARATOR), item[key]);
          }

        })

      // se añaden los lookups ids
      ds.dataSource?.iapDataSourceFields?.filter(dsField => dsField.dataSourceLookUpId != null).map(x => ({ dataSourceFieldId: x.id, dataSourceLookUpId: x.dataSourceLookUpId, iapDataSourceFields: x.dataSourceLookUp?.dataSource.iapDataSourceFields }))
        //.filter(x =>  dictionaryKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, ds.id, dsField.id].join('.')))
        .forEach(x => {
          x.iapDataSourceFields?.filter(dsField => dictionaryKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, dsField.id].join('.')))
            .forEach(dsField => {

              //@ts-ignore:disable-next-line
              let _field = x.dataSourceFieldId.replaceAll('-', '') + DataSourceConst.DELIMITERFIELDS + dsField.id.replaceAll('-', '');

              const _value = item != null ? item[_field] : null;
              updateDictionary([ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, dsField.id].join('.'), _value);

            })
        })

    }
  }

  const fillDataSource = async (ds: IapComponentDataSource): Promise<boolean> => {
    return await new Promise<boolean>((resolve) => {
      const claves = ds.dataSource.iapDataSourceFields.filter(x => x.filterValue).map(x =>
      ({
        field: x,
        filter: FiltroBusquedaConst.FILTROBUSQUEDA_IGUAL,
        value: x.filterValue,
        valueList: (x.catalogTypeId ? [x.filterValue] : null),
        valueBool: null,
        valueNumber: null,
        valueDateTime: null,
        rangeValue: null,
        rangeNumber: null,
        rangeDateTime: null

      }));

      if (container) {
        claves.forEach(item => {
          if (item.field && item.field.dataSourceLookUp) {
            item.field.dataSourceLookUp = null;
          }
        });
        const _claves = JSON.parse(JSON.stringify(claves))
        const _srv = container.get<IServiceSearch>(
          TYPES.SEARCH_REPOSITORY
        );
        HelperLoading.showLoading();
        _srv.search(componentInput.applicationId, componentInput.applicationVersion, componentInput.id,
          _claves as any, ds.maxRowsReturned, ds.id)
          .then((response) => {


            const obj = JSON.parse(response?.items ?? '[]');
            const { generateFormatCol } = DataSourceUtilComp(ds,store)
            //se formatean las columnas
            generateFormatCol(obj)
            HelperUtils.handleDates(obj)
            //ds.dataSource.items = obj

            if (ds.dataSource.items == null) {
              ds.dataSource.items = []
            }

            Object.assign(ds.dataSource.items, obj);


            updateCdsDependencies(ds, obj)

          })
          .catch((err) => {

          })
          .finally(() => {

            HelperLoading.hideLoading();
            resolve(true);
          });

      }

    });

  }




  const resolveAllExpressions = (): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
      if (Component.iapComponentAttributes.find(x => x.idAttributeType == CatalogAttrConst.TIPOATTR_PROPCUS)) {
        resolveAttributes().then(() => {
          resolveDatasource().then(() => {
            resolve(true);
          });
        });
      }
      else {
        resolveDatasource().then(() => {
          resolveAttributes().then(() => {
            resolve(true);
          });
        });

      }

    })



  }

  const resolveDatasource = async () => {
    return new Promise<boolean>((resolve) => {
      var promises = new Array();

      if ((Component.iapComponentDataSources?.length ?? 0) > 0) {
        Component.iapComponentDataSources.forEach(ds => {
          ds.dataSource.iapDataSourceFields.filter(f => hasExpressions(CatalogObjectTypeConst.DSF, [f.id, ds.id].join('#'), CatalogExpConst.EXP_FILTER)).forEach(f => {
            f.filterValue = resolveExpressions(CatalogObjectTypeConst.DSF, [f.id, ds.id].join('#'), CatalogExpConst.EXP_FILTER);
          })

          // SE LLAMA CON LOS FILTROS DE LOS DATASOURCES        
          if (ds.autoLoad) {
            promises.push(fillDataSource(ds))

          }

        })
        if (promises.length > 0) {


          Promise.all(promises)
            .then(() => {

              resolve(true);
            });

        }
        else {
          resolve(true);
        }
      }
      else {
        resolve(true);
      }


    });


  }

  const resolveAttributes = () => {
    return new Promise<boolean>((resolve) => {
      Component.iapComponentAttributes.filter(f => hasExpressions(CatalogObjectTypeConst.ATTRCOMP, f.id, CatalogExpConst.EXP_SET)).forEach(att => {
        att.value = resolveExpressions(CatalogObjectTypeConst.ATTRCOMP, att.id, CatalogExpConst.EXP_SET);
        updateDictionary([ExpressionNomenclatorConst.EXPNOM_ATTRIBUTES, att.id].join(ExpressionNomenclatorConst.SEPARATOR), att.value);
      })
      resolve(true);
    });
  }


  const hasExpressions = (idObjeto = CatalogObjectTypeConst.ATTRCOMP, objetoId: string, idTypeExpression = CatalogExpConst.EXP_SET) => {

    const exps = Component.expressions?.filter(x => x.idObjeto == idObjeto && x.idTypeExpression == idTypeExpression && (objetoId == null || x.objetoId == objetoId) && x.iapExpressionDetails?.length > 0);
    return (exps?.length > 0)

  }


  const resolveExpressions = (idObjeto = CatalogObjectTypeConst.ATTRCOMP, objetoId: string | null = null, idTypeExpression = CatalogExpConst.EXP_SET, expressions: IapExpression[] | null = null) => {
    let resu: any = null;
    const expressionsData = expressions ?? Component.expressions;
    const exps = expressionsData?.filter(x => x.idObjeto == idObjeto && x.idTypeExpression == idTypeExpression && (objetoId == null || x.objetoId == objetoId));

    if (exps?.length > 0) {
      exps?.every(exp => {
        if (exp.iapExpressionDetails?.length > 0) {

          const localData = LocalService.getValue(LocalService.COMPONENTS_EXP + (rootParentId ?? -1).toString());
          const data = JSON.parse(localData ?? '[]')
          resu = ExpresionEngine.resolveExpressions(exp.iapExpressionDetails, data as any)

          //resu = resu?.toString();
          if (resu) {
            if (Object.keys(resu).length == 0) {
              resu = resu?.toString();
            }
          }



          /*if (idObjeto == CatalogObjectTypeConst.ATTRCOMP && idTypeExpression==CatalogExpConst.EXP_SET){
             setPropertyValue(exp.objetoId, resu?.toString())
          }
          else{
            if (idObjeto == CatalogObjectTypeConst.DSF && idTypeExpression==CatalogExpConst.EXP_FILTER){
              resu = resu?.toString();
              return resu;
            }

          }
          */
          /*
          if (idTypeExpression==CatalogExpConst.EXP_FILTER){
            setPropertyValue(exp.objetoId, resu?.toString())
          }
          */

        }
      })

    }

    return resu;

  }


  const modelValueKeys = getModelValueKeys();
  const canAutoSaveDatasourceComponent = isAutoSaveDatasourceComponent();

  const getComponentDataSourceFieldConfiguration = (): IapComponentDataSourceFieldConfiguration | null | undefined => {
    if (modelValueKeys && modelValueKeys?.type == CatalogModelValueConst.MODELVALUE_DATASOURCE) {
      const _dataK = modelValueKeys as KeysDataModelComponentDataSource
      const dsc = componentDataSources.value.find(x => x.id == _dataK.componentDataSourceId);
      if (dsc) {
        return dsc.iapComponentDataSourceFieldConfigurations.find(x => x.dataSourceFieldId == _dataK.dataSourceFieldId);
      }
    }

    return null;
  }

  const getDataSourceFieldConfiguration = (): IapDataSourceField | null | undefined => {
    if (modelValueKeys && modelValueKeys?.type == CatalogModelValueConst.MODELVALUE_DATASOURCE) {
      const _dataK = modelValueKeys as KeysDataModelComponentDataSource
      const dsc = componentDataSources.value.find(x => x.id == _dataK.componentDataSourceId);
      if (dsc) {
        return dsc.dataSource.iapDataSourceFields.find(x => x.id == _dataK.dataSourceFieldId);
      }
    }

    return null;
  }

  //validaciones de las cosas

  const componentDataSourceFieldConfiguration = getComponentDataSourceFieldConfiguration();
  const dataSourceFieldConfiguration = getDataSourceFieldConfiguration();
  const canEdit = true;// (componentDataSourceFieldConfiguration?.edit ?? false);

  const rules = computed(() => ({
    vmodel: {
      required: helpers.withMessage('El campo es obligatorio', requiredIf((...args) => {
        var data = args[args.length - 2] as any;
        const fieldNullable = dataSourceFieldConfiguration?.nullable ?? true;
        const mandatory = componentDataSourceFieldConfiguration?.mandatory ?? false;
        const isValidData = !(data == null || data == undefined || data == '')
        return ((fieldNullable == false) || mandatory) && (!isValidData);

      }))
    }
  }));

  const v$ = useVuelidate(rules, { vmodel })


  const isValidData = (): boolean => {

    submitted.value = true;
    v$.value.$reset();
    v$.value.$touch();
    if (v$.value.$invalid) {
      HelperCommon.setFocusOnFirstError();
      return false;
    }

    return true;

  }





  const updateData = (_newValue: any, start: boolean = false) => {
    if (start && loaded) {

      if (modelValueKeys && modelValueKeys?.type == CatalogModelValueConst.MODELVALUE_DATASOURCE && canAutoSaveDatasourceComponent) {
        const _dataK = modelValueKeys as KeysDataModelComponentDataSource
        const cds = componentDataSources.value.find(x => x.id == _dataK.componentDataSourceId);
        if (cds) {

          const { getPrimaryKeys } = DataSourceUtilComp(cds,store)
          const _data = cds.dataSource.items.find((y: any) => y !== undefined);
          const dsf = cds.dataSource.iapDataSourceFields.find(x => x.id == _dataK.dataSourceFieldId);//  _field == (dataBaseId.value + DELIMITERFIELDS + x.tableName + DELIMITERFIELDS + x.field))?.tableName          
          const tableName = dsf?.tableName ?? '';
          const _field = cds.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + tableName + DataSourceConst.DELIMITERFIELDS + dsf?.field;
          const mustSerialize = (dsf?.sqlType == SqlTypesConst.BIT) ?? false;
          const dataUpdate: dataUpdate = {
            valores: [{
              dataBase: cds.dataSource?.iapDataSourceDataBase?.idBaseDatos as any,
              table: tableName as any,
              field: _field as any,
              value: mustSerialize ? JSON.stringify(_newValue) as any : _newValue as any,//JSON.stringify(newValue) as any
            }],
            claves: getPrimaryKeys(cds.dataSource, _data as any, tableName as any),
            tipoOperacion: OperationDataTypeConst.UPDATE,
            id: HelperUtils.newGuid()
          };


          // se añaden los autoupdate de la configuración del componentdatasource
          const { tablasData, dataBaseId, formatData, getDefaultvalue } = DataSourceComp(props.container as any, props, {}, {}, cds as any, catalogTypes().flatMap(x => x.iapCatalogs), store)
          cds.iapComponentDataSourceFieldConfigurations.filter(x => x.autoUpdate == true)
            .forEach(cfg => {
              const _fieldToUpdate = tablasData.value.find(x => x.id == cfg.dataSourceFieldId && x.tableName == tableName);
              if (_fieldToUpdate) {

                const newField = (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate.tableName + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate.field);
                const newTableName = _fieldToUpdate?.tableName;
                const newFieldValue = getDefaultvalue(_fieldToUpdate, cfg.defaultValue)
                //data[field] = newValue


                if (
                  (_fieldToUpdate?.nullable == true) // columnas que admiten nulos
                  || (_fieldToUpdate?.nullable == false && !(newFieldValue == null || newFieldValue == undefined))) // columnas no nulas que llegan valores nulos
                {

                  const mustSerialize = (_fieldToUpdate?.sqlType == SqlTypesConst.BIT) ?? false;
                  dataUpdate.valores.push
                    (
                      {
                        dataBase: cds.dataSource?.iapDataSourceDataBase?.idBaseDatos ?? '',
                        table: tableName ?? '',
                        field: newField,
                        value: mustSerialize ? JSON.stringify(newFieldValue) as any : newFieldValue as any,//JSON.stringify(newValue) as any
                      })
                }


              }
            })

          const doOperationTransaction = dataUpdate.valores.length > 1;
          HelperOperationData.doOperationData(props.container, cds, [dataUpdate], doOperationTransaction);
        }

      }

    }

  }



  const insertData = async (cds: IapComponentDataSource, exps: IapExpression[]): Promise<boolean> => {
    return await new Promise<boolean>((resolve) => {

      let dataInput: claveNew[] = ([]);

      const {
        isColumnType,
        dataBaseId } = DataSourceUtilComp(cds,store)


      const tablasData = cds.dataSource.iapDataSourceFields;
      const itemDataRow = cds.dataSource.items?.find((x: any) => x !== undefined)
      if (itemDataRow == undefined || itemDataRow == null) {
        MessageService.showMessage(MessageType.Error, 'Error de inserción de datos', 'No hay datos que insertar.');
        resolve(false);
      }
      else {

        // se ponen los valores por defecto usando el autoUpdate

        const { dataBaseId, formatData, getDefaultvalue } = DataSourceComp(props.container as any, props, {}, {}, cds as any, catalogTypes().flatMap(x => x.iapCatalogs), store)
        cds.iapComponentDataSourceFieldConfigurations.filter(x => x.autoUpdate == true)
          .every(cfg => {
            const _fieldToUpdate = tablasData.find(x => x.id == cfg.dataSourceFieldId);
            if (_fieldToUpdate) {

              const newField = dataBaseId.value + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate.tableName + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate.field;
              const newFieldValue = getDefaultvalue(_fieldToUpdate, cfg.defaultValue, exps)

              if (
                (_fieldToUpdate?.nullable == true) // columnas que admiten nulos
                || (_fieldToUpdate?.nullable == false && !(newFieldValue == null || newFieldValue == undefined))) // columnas no nulas que llegan valores nulos
              {

                itemDataRow[newField] = newFieldValue;
              }
              else {
                MessageService.showMessage(MessageType.Error, 'Error de inserción de datos', 'Valor nulo en campo no nulo.');
                resolve(false);
                return false;
              }

              return true;
            }
          })

        // fin valores por defecto


        dataInput = tablasData.filter(x => ((!x.identityColumn && !x.primaryKey) || (!x.identityColumn && x.primaryKey))
          && cds.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.add
        )
          .sort((a, b) => { return (a.position ?? 0) - (b.position ?? 0); })
          .map(x => ({
            dataBase: dataBaseId.value,
            table: x.tableName,
            field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field,
            value: itemDataRow[dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field], //getDefaultvalue(x),
            required: !x.nullable || cds.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.mandatory
          })) as any


        const valuesNoAdd = tablasData.filter(x => ((!x.identityColumn && !x.primaryKey) || (!x.identityColumn && x.primaryKey))
          && !cds.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.add
        )
          .sort((a, b) => { return (a.position ?? 0) - (b.position ?? 0); })
          .map(x => ({
            dataBase: dataBaseId.value,
            table: x.tableName,
            field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field,
            value: itemDataRow[dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field],  //,getDefaultvalue(x),
            required: !x.nullable || cds.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.mandatory
          })) as any

        const dataInputRequest = JSON.parse(JSON.stringify(dataInput.concat(valuesNoAdd)));

        const dataUpdate: dataUpdate = {
          valores: dataInputRequest.map((x: any) => ({
            dataBase: x.dataBase,
            table: x.table,
            field: x.field,
            value: isColumnType(x.field, SqlTypesConst.BIT) ? JSON.stringify(x.value) : x.value
          })) as any,
          claves: [],
          tipoOperacion: OperationDataTypeConst.INSERT,
          id: HelperUtils.newGuid()
        };


        if (dataUpdate.valores.length == 0) {
          MessageService.showMessage(MessageType.Error, 'Error de inserción de datos', 'No hay valores que insertar.');
          resolve(false);
        }
        else {
          const resultOperation = HelperOperationData.doOperationData(props.container, cds, [dataUpdate], false)
          resolve(resultOperation);
        }

      }

    })
  }


  const setLookUpReference = () => {
    
    // se va a actualizar el lookupdescription
    const cds = getComponentDataSourceFromModelValue()
    if (fieldKey.value && lookUpData.value && cds) {
      // const originalData = cds.dataSource.items[0] as any
      const campo = fieldKey.value;
      const { tablasData, dataBaseId, formatData } = DataSourceComp(props.container as any, props, {}, {}, cds as any, catalogTypes().flatMap(x => x.iapCatalogs), store)
      //const tablasData  = cds.dataSource.iapDataSourceFields;
      const dsLk = tablasData.value.find(x => campo == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))
      //console.log('ACTUALIZANDO:rootParentId.toString() + fieldKey + fieldKeyComponentDataSourceId.value.toString()')

      // se actualizan el resto de campos
      Object.keys(lookUpData.value).filter(x => x != DataSourceConst.LOOKUPID
        && x != DataSourceConst.LOOKUPDESC
      ).forEach(_field => {
        const newValue = lookUpData.value[_field]
        const dslnkFields = dsLk?.dataSourceLookUp?.dataSource.iapDataSourceFields.map(x => ({ id: x.id, field: (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + (!HelperCommon.isNullOrWhitespace(x.tableNameAlias??'')?x.tableNameAlias: x.tableName) + DataSourceConst.DELIMITERFIELDS + x.field) }));
        const dataSourceFieldIdSource = dslnkFields?.find((x: any) => x.field == _field)?.id;
        const dataSourceFieldIdTarget = dsLk?.dataSourceLookUp?.iapDataSourceLookUpFieldMaps.find(x => x.dataSourceFieldIdSource == dataSourceFieldIdSource)?.dataSourceFieldIdTarget;

        const _fieldToUpdate = tablasData.value.find(x => x.id == dataSourceFieldIdTarget)

        if (_fieldToUpdate) {


          const _fieldNew = (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + (_fieldToUpdate?.tableNameAlias ?? _fieldToUpdate?.tableName) + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate?.field)

          var data: Partial<InteractionEvent> = {
            typeId: InteractionConst.SET_VMODEL,
            objectValue: newValue

          }
          //console.log(rootParentId.toString() + _fieldNew + fieldKeyComponentDataSourceId.value.toString())
          EventBus.emit(rootParentId.toString() + _fieldNew + fieldKeyComponentDataSourceId.value.toString(), { data: data, callBackResponse: null });
        }

      })

      lookUpData.value = null;

    }
  }


  const initDebounce = () => {
    debounceUpdateData = debounce((data: any, start: boolean = false) => {
      updateData(data, start)
    }, debounceTime);
  }


  const baseOnMounted = () => {


    if (canAutoSaveDatasourceComponent) {

      initDebounce()

      watch(
        vmodel, (newvalue, oldvalue) => {
          if (oldvalue !== newvalue && oldvalue !== undefined) {
            if (isValidData()) {
              setModelValue(newvalue)
              setLookUpReference();
              debounceUpdateData(newvalue, true);
            }
          }
        },
        {
          flush: 'post',
          //immediate: true, 
          deep: true
        }
      )
    }
    else {
      watch(
        vmodel, (newvalue, oldvalue) => {
          if (loaded.value && oldvalue !== newvalue) {
            setModelValue(newvalue)
            setLookUpReference();
          }
        },
        {
          flush: 'post',
          //immediate: true, 
          deep: true
        }
      )
    }





  }



  const getPropertyValueOptions = (propertyName: string, component = Component) => {

    if (dataSourceFieldConfiguration && dataSourceFieldConfiguration?.catalogTypeId) {
      return getCatalogs(dataSourceFieldConfiguration?.catalogTypeId)

    }

    return component.iapComponentAttributes.find((x) => x.name == propertyName)
      ?.value;
  };

  // se sobrecargan los metodos base

  const baseOnBeforeUnmount = () => {


    if (canAutoSaveDatasourceComponent) {
      debounceUpdateData.cancel();
    }

  }

  const baseOnUnmount = () => {

    componentInput.loaded = false
    vmodel.value = null;

    Component.iapComponentDataSources?.forEach(cds => {
      cds.dataSource.items = null;
      updateCdsDependencies(cds, null)
    })

    EventBus.off(keyComponentEventBus, (evt: { data: InteractionEvent, resolve: any, reject: any }) => { });


  }

  const markUnloadComponents = (tree: any) => {

    const dsc = getTreeFlat(tree, "loaded")
    if (dsc) {
      dsc?.forEach(x => {
        x.loaded = false;
      })
    }
  }


  const doOperationEvent = (evt: { data: InteractionEvent, callBackResponse: any }) => {

    switch (evt.data.typeId) {
      case InteractionConst.GET_PROPERTY_VALUE:

        const attrGet = Component.iapComponentAttributes?.find(x => x.id == evt.data.objectId || x.name == evt.data.objectName)
        if (attrGet) {
          evt.data.interactionResult = attrGet.value;
        }

        break;
      case InteractionConst.SET_PROPERTY_VALUE:

        const attrSet = Component.iapComponentAttributes?.find(x => x.id == evt.data.objectId || x.name == evt.data.objectName)
        if (attrSet) {
          setPropertyValue(attrSet.id, evt.data.objectValue)
          evt.data.interactionResult = attrSet.value;
        }
        break;
      case InteractionConst.GET_VMODEL:
        evt.data.interactionResult = vmodel.value
        break;
      case InteractionConst.SET_VMODEL:
        vmodel.value = evt.data.objectValue;
        evt.data.interactionResult = vmodel.value
        break;
      case InteractionConst.CALL_FUNCTION:

        if (evt.data.objectName?.toLowerCase() == 'isvaliddata()') {
          evt.data.interactionResult = isValidData()
        }
        else if (evt.data.objectName?.toLowerCase() == 'getcurrentexpr()') {
          evt.data.interactionResult = getCurrentExpr();
        }
        else if (evt.data.objectName?.toLowerCase() == 'processevent()'){
          processEvent(CatalogObjectTypeConst.EVTCOMP,evt.data.objectValue)
          evt.data.interactionResult =evt.data.objectValue
        }
        break;
    }

    if (evt.callBackResponse) {
      evt.callBackResponse(evt.data);
    }
  }



  const getCurrentExpr = (): IapExpression[] => {
        return  componentInput.expressions;
  }



  // se llama parea que resuelta todas las expresiones que contiene
  resolveAllExpressions().then((result: boolean) => {

    componentInput.loaded = true
    vmodel.value = getModelValue();


    //console.log('ORIGINAL:rootParentId.toString() + fieldKey + fieldKeyComponentDataSourceId.value.toString()')
    //console.log(rootParentId.toString() + fieldKey.value + fieldKeyComponentDataSourceId.value.toString())
    EventBus.on(rootParentId.toString() + fieldKey.value + fieldKeyComponentDataSourceId.value.toString(), (evt: { data: InteractionEvent, callBackResponse: any }) => {      
      doOperationEvent(evt);
    })


    EventBus.on(keyComponentEventBus, (evt: { data: InteractionEvent, callBackResponse: any }) => {
      doOperationEvent(evt);
    })


  });


  const processEvent = async  (idObjeto: string, objetoId: string, componentInput: WidgetComponentDataTree | null = null) => {
    let wf: IapWorkFlow | null = null;
    const comp = componentInput ?? props.Component

    switch (idObjeto) {
      case CatalogObjectTypeConst.ATTRCOMP:
        wf = comp.workFlows?.find((x: IapWorkFlow) => x.idObjeto == idObjeto && x.objetoId == objetoId)
        break;

      case CatalogObjectTypeConst.EVTCOMP:
        const eventId = comp.iapComponentEvents.find((x: IapComponentEvent) => x.id == objetoId && x.active == true)?.id ?? ''
        wf = comp.workFlows?.find((x: IapWorkFlow) => x.idObjeto == idObjeto && x.objetoId == eventId)

        break;

      default:
        break;
    }


    if (wf) {      
      HelperLoading.showLoading()
      await fetchWrapper.get(Environment.URL_COMPONENT + rootParentId.toString() + '.json'+ '?_t='+ new Date().getTime().toString() ,store)
      .then( async (response: IapComponent[]) => {   
        await executeWorkFlow(wf as any, comp.applicationId, comp.applicationVersion, rootParentId, comp.id,response, [] as any, props.container, store, router)
      })
      .catch(()=>{
        HelperLoading.hideLoading()
        MessageService.showMessage(MessageType.Error, 'Error de interacción', 'No hay datos en el nodo raíz.');        
      })
      .finally(() => {
        HelperLoading.hideLoading()
    })
      
    }

  }


  const processEventComponent = (idEventType: string, componentInput: WidgetComponentDataTree | null = null) => {
    const comp = componentInput ?? props.Component
    const eventId = comp.iapComponentEvents.find((x:IapComponentEvent) => x.idEventType == idEventType && x.active==true)?.id ?? ''
    if (eventId){
      processEvent(CatalogObjectTypeConst.EVTCOMP,eventId,comp)
    }
  }


  const isSeparator = (component: WidgetComponentDataTree): boolean => {

    const separatorObject = component.iapComponentAttributes.find((x) => x.name === MenuItemTypeConst.SEPARATOR);
    let separator: boolean = false;

    if (separatorObject !== undefined) {
      separator = booleanify(separatorObject.value);
    } else {
      separator = false;
    }

    return separator;

  };


  const buildMenu = (menuItem: WidgetComponentDataTree[] = props.Component.children) => {

    var menuItems: Partial<MenuItemClass>[] = [];

    menuItem.filter(x => x.idType == ControlTypeConst.CTMENUITEM).forEach(x => {

      let item: Partial<MenuItemClass>;

      if (isSeparator(x)) {

        item = {
          separator: true,
        }

      }
      else {
        
        item = {

          key: x.id.toString(),
          label: getPropertyValue(MenuItemTypeConst.LABEL, x),
          visible: getPropertyBooleanValue(MenuItemTypeConst.VISIBLE, x),
          icon: getPropertyValue(MenuItemTypeConst.ICON, x),
          class: getPropertyValue(MenuItemTypeConst.CLASS, x),
          items: null,
          command: (data: any) => {
            processEvent(CatalogObjectTypeConst.ATTRCOMP, getPropertyId(MenuItemTypeConst.COMMAND, x) ?? '', x)

          }

        }

        
        const _items =  buildMenu(x.children) ?? [];
        if (_items?.length > 0){
          item.items = _items;
        }
        

      }

      menuItems.push(item);

    });

    return menuItems as any[];

  };


  const getLayoutComponent = (Component: WidgetComponentDataTree, idType: string) => {

    return Component.children.find(x => x.idType == idType)
  }

  const getAllLayoutComponent = (Component: WidgetComponentDataTree, idType: string) => {

    return Component.children.filter(x => x.idType == idType)
  }

  const getContentComponent = (Component: WidgetComponentDataTree, idType: string) => {
    return Component.children.find(x => !x.idType.startsWith('layouttemp'))
  }

  const isLayoutComponent = (Component: WidgetComponentDataTree) => {
    return Component.idType.toLocaleLowerCase().startsWith('layouttemp')
  }



  return {
    v$,
    submitted,
    canEdit,
    getPropertyValue,
    getPropertyId,
    getPropertyValueOptions,
    setPropertyValue,
    getPropertyBooleanValue,
    getPropertyNumberValue,
    resolveExpressions,
    resolveDatasource,
    vmodel,
    loaded,
    componentData,
    getCatalogValue,
    getProperty,
    updateDictionary,
    dictionaryKeys,
    setPropertyValueByName,
    markUnloadComponents,
    baseOnMounted,
    baseOnBeforeUnmount,
    baseOnUnmount,
    buildMenu,
    getLayoutComponent,
    getContentComponent,
    isLayoutComponent,
    processEvent,
    processEventComponent,
    getAllLayoutComponent,
    getDsLookUpId,
    getDsFieldsLookUp,
    getDsLookUp,
    isValidData,
    insertData,
    lookUpData,
    fieldKey,
    fieldKeyComponentDataSourceId,
    getComponentDataSourceFromModelValue,
    getDsLookUpDesc,
    catalogTypes,
    getPropertyValueOption,
    doOperationEvent,
    getComponentDataSourceItemsFromId,
    getOptionLabelAutocomplete,
    getComponentDataSource

  };
}
